import styled from "styled-components";
import AsonicIconButton from "../shared/asonic-icon-button/asonic-icon-button";
import { ITextInputProps } from "./text-input-with-label";
import SearchIcon from "@iconify/icons-flat-color-icons/search";
import { forwardRef } from "react";

interface IProps extends ITextInputProps {
  handleSearch: () => void;
}

const Container = styled.div`
  display: flex;
  font-size: 20px;
  align-items: center;
  gap: 10px;
`;

const Input = styled.input<{ minWidth?: string }>`
  display: flex;
  flex: 12;
  min-width: ${props => props.minWidth || ""};
`;

const Label = styled.label`
  font-size: 12px;
  color: ${props => props.theme.colors.darkGrey};
  flex: 1;
  min-width: max-content;
`;

function SearchInput(props: IProps, ref: any) {
  return (
    <Container>
      {props.required && <span>*</span>}
      <Label htmlFor={props.title}>{props.title}</Label>
      <Input
        placeholder={props.title}
        {...props}
        ref={ref}
        id={props.title}
        type={props.type ?? "text"}
        minWidth={props.minWidth}
      />
      <AsonicIconButton icon={SearchIcon} onClick={props.handleSearch} />
    </Container>
  );
}

export default forwardRef(SearchInput);
